import React from "react";
import DropdownIcon from "../../assets/images/dropdown-icon.png";

export const inputCls =
  "mt-2 h-[44px] w-full rounded-[6px] border border-[#DFE3EB] bg-[#F1F5F9] px-3 pr-8 text-[14px] text-[#3D3D3D] outline-none placeholder:text-[#A7A7A7] disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed disabled:border-gray-300";

export const Field: React.FC<{
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
}> = ({ label, required, error, children }) => (
  <div className="block">
    <div className="text-[13px] font-semibold text-[#3B3B3B]">
      {label} {required && <span className="text-[#E54848]">*</span>}
    </div>
    {children}
    {!!error && (
      <span className="mt-1 block text-[12px] text-[#FF0000]">{error}</span>
    )}
  </div>
);

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => <input ref={ref} className={inputCls} {...props} />);
Input.displayName = "Input";

const SelectWrap: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="relative">
    {children}
    <img
      src={DropdownIcon}
      alt=""
      className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-3 w-3"
    />
  </div>
);

export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>((props, ref) => (
  <SelectWrap>
    <select ref={ref} className={`${inputCls} appearance-none`} {...props} />
  </SelectWrap>
));
Select.displayName = "Select";
